import { game, user } from '../store/store';
import { subscribe } from 'svelte';
import { apiUrlGet } from './common';
import { sumGameInit } from './session_common'; 

let userSess = '';
let gameSess = '';

user.subscribe((val) => userSess = val);
game.subscribe((val) => gameSess = val);

export async function playAction(fieldInd) {
  console.log("playAction", fieldInd);
  const gameId = gameSess.id;
  const userId = userSess.id;
  const playActionUrl =  apiUrlGet(`game/play/${gameId}/play_action/`);
  const action = "select";  
  let playActionOb = {
    action,
    fieldInd,
    userId,
  };
  await fetch(playActionUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(playActionOb),
    credentials: 'include',
  });
  // await sumGameInit();
}
